import axios from '@/utils/axios';
import Vue from "vue";

export const formMethods = {
  data() {
    return {
      selectItems: []
    }
  },
  created() {
  },
  methods: {
    getOptions(url, filter_field = null, query = null, label, value, returnId) {
      let params;
      if (filter_field) {
        params = {filter: {}};
        params.filter[filter_field] = query;
      } else {
        params = {}
      }
      return axios.get(url, {params}).then(({data}) => {
        if (data && data.items) {
          this.selectItems = data.items.map(option => {
            if (option[label]) {
              if (returnId) {
                return {
                  label: option[label],
                  value: option[value],
                  id: option.id
                }
              } else {
                return {
                  label: option[label],
                  value: option[value]
                }
              }
            }
          });
        }
      })
    },
    getData(url, params, redirect, hideError=true, invite, rawError = false) {
      return axios.get(`/admin/${url}`, params)
          .then(resp => {
            if (resp) {
              return resp
            }
          })
          .catch(e => {
            if (!hideError && e && e.response) {
              console.log(e.response.status === 409)
              if (invite && e.response.status === 409) {
                // for already used invite code
                this.$noty.error('Invitation code already used. Please use <a href="/login" style="text-decoration: underline">dashboard login page</a> instead.', {timeout: false});
              } else {
                this.$noty.error(e.response.data.error_description);

                if (rawError) {
                  throw e;
                }
              }
            }
            if (redirect) {
              this.$router.replace({name: '404'})
            }
          })
    },
    postData(url, params, redirect_url, hideAlert = false, publicRequest = false) {
      const urlRequest = publicRequest ? url : `/admin/${url}`;

      return axios.post(urlRequest, params)
          .then(resp => {
            if (resp) {
              if (!hideAlert) {
                this.$noty.success(this.$t('global.success'));
              }
              if (redirect_url) {
                this.$router.push({path: redirect_url})
              }
              return resp
            }
          })
          .catch(e => {
            if (e && e.response) {
              this.$noty.error(e.response.data.error_description)
            }
          })
    },
    putData(url, params, redirect_url, hideAlert = false) {
      return axios.put(`/admin/${url}`, params)
          .then(resp => {
            if (resp) {
              if (!hideAlert) {
                this.$noty.success(this.$t('global.success'));
              }
              if (redirect_url) {
                this.$router.push({path: redirect_url})
              }
              return resp
            }
          })
          .catch(e => {
            if (e && e.response) {
              this.$noty.error(e.response.data.error_description)
            }
          })
    },
    patchData(url, params, redirect_url) {
      return axios.patch(`/admin/${url}`, params)
          .then(resp => {
            if (resp) {
              this.$noty.success(this.$t('global.success'));
              if (redirect_url) {
                this.$router.push({path: redirect_url})
              }
              return resp
            }
          })
          .catch(e => {
            if (e && e.response) {
              this.$noty.error(e.response.data.error_description)
            }
          })
    },
    deleteData(url, hideAlert = false, redirect_url, params) {
      return axios.delete(`/admin/${url}`, params || null)
          .then(resp => {
            if (resp) {
              if (!hideAlert) {
                this.$noty.success(this.$t('global.success'));
              }
              if (redirect_url) {
                this.$router.go(-1)
              }
              return resp
            }
          })
          .catch(e => {
            if (e && e.response) {
              this.$noty.error(e.response.data.error_description)
            }
          })
    },
    getCountries(url, params) {
      if (url === 'countries' || url === '/countries') {
        url = 'admin/countries'
      }
      return axios.get(`/${url}`, params)
          .then(resp => {
            if (resp) {
              return resp
            }
          })
          .catch(e => {
            if (e && e.response) {
              this.$noty.error(e.response.data.error_description);
            }
          })
    },
    authorize(params) {
      return axios.post(`/admin/authorization`, params)
          .then(resp => {
            if (resp) {
              return resp
            }
          })
          .catch(e => {
            if (e && e.response) {
              this.$noty.error(e.response.data.error_description)
            }
          })
    },
    checkRequiredSelects(ids) {
      let invalids = 0;
      ids.map(id => {
        let input = document.getElementById(id);
        if (input) {
          input.classList.add('invalid')
        }
        console.log(id, input)
      });
    },
    exportList(params, type) {
      console.log(params, type)
      return axios({url: `/admin/${type}`, params: params, method: 'GET', responseType: 'blob'}).then(({data}) => {
        let blob = new Blob([data], {type: 'application/vnd.ms-excel'});
        let downloadUrl = URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `${type}_${this.getCurrentDate()}.xlsx`;
        document.body.appendChild(a);
        a.click();

        return true;
      })
    },
    generateXmlList(params, type) {
      console.log(params, type)
      axios({url: `/admin/${type}`, params: params, method: 'GET', responseType: 'json'}).then(({data}) => {
        if(data.success) this.$noty.success(this.$t('global.link_sent'));
        else this.$noty.error(this.$t('global.task_already_exist'));
      })
    },
    maskIPValidator(input, ipValidator = false) {
      if (!input) {
        return false
      }
      let splitter = /[./]/;
      let inputArr = input.split(splitter).filter(item => item !== '');
      if (ipValidator && inputArr.length < 4) {
        return false;
      } else if (!ipValidator && inputArr.length < 5) {
        return false
      }
      let numRegexp = /^(\d+)$/;
      for (let i in inputArr) {
        if (!numRegexp.test(inputArr[i])) {
          return false
        }
        if (inputArr[i].length > 3) {
          return false
        }
        if (inputArr[i] !== Number(inputArr[i]).toString()) {
          return false
        }
      }
      inputArr = inputArr.map(item => {
        return Number(item)
      })
      for (let i in inputArr) {
        if (inputArr[i] < 0 || inputArr[i] > 255) {
          return false
        }
      }
      return true
    },
  }
};
